import { useState } from "react";
import LineTemplate from "./Components/LineTemplate";
import GridTemplate from "./Components/GridTemplate";
import "./LinksComponentDashboard.css";
import { useLoadUserLinks } from "./Utils/useLoadUserLinks";
import { deleteUserLinks } from "../../../../../Utils/SupabaseServices/UserLinksDatabase";
import { MyLinksSkeleton } from "../../../../../components/skeleton/DashboardView/myLinksSkeleton";
import { isNavigable } from "../../../../../Utils/StayUpToDate/RenderComponent";
import { useDesign } from "../../../../../context/DesignContext";
import { withLayoutDisplayImage } from "../../../../../Utils/imageCrop/ensureLinkLayoutDefaultCrop";
import { useWebsiteLibEditAsDrawer } from "../../../../../components/EditModalComponents.tsx/WebsiteLibEditAsDrawerContext";

const LinksComponentFrontend = (props: any) => {
  const {
    component,
    username,
    user_id,
    brand_color,
    handleRedirect,
    from,
    pageFrom,
    designTokens,
    isMobileView,
  } = props;

  const websiteEdit = useWebsiteLibEditAsDrawer();
  const {
    primaryColor,
    secondaryColor,
    tertiaryColor,
    fontFamily,
    primaryFont,
    secondaryFont,
  } = useDesign();
  const effectiveTokens = designTokens ?? {
    primaryColor,
    secondaryColor,
    tertiaryColor,
    fontFamily,
    primaryFontFamily: primaryFont,
    secondaryFontFamily: secondaryFont,
  };

  const { name, details } = component;
  const titleText = String(
    (component as any)?._liveHeading || name || "",
  ).trim() || name;
  const componentId = component?.id || null;
  const isGridLayout = String(details ?? "").trim() === "grid";
  const { data, isLoading } = useLoadUserLinks(
    user_id,
    name,
    from,
    componentId,
  );
  const [templates, setTemplates] = useState<any>([
    {
      id: 0,
      link_name: "",
      link_url: "",
      image_url: null,
      index: 0,
    },
  ]);

  const handleRemoveTemplate = (id: number) => {
    const updatedTemplates = templates.filter(
      (template: any) => template.id !== id,
    );
    if (updatedTemplates.length === 0) {
      setTemplates([1]);
    } else {
      setTemplates(updatedTemplates);
    }

    deleteUserLinks(user_id, name, id, from, componentId);
  };

  const titleEl = (
    <div className="mainDiv">
      <p
        className="component-name line-layout-section-title links-section-title"
        style={{
          fontFamily: effectiveTokens?.primaryFontFamily,
          cursor: isNavigable({
            display_name: name,
            type: component.type,
          })
            ? "pointer"
            : "default",
        }}
      >
        {titleText}
      </p>{" "}
    </div>
  );

  if (isLoading) {
    return (
      <div>
        <MyLinksSkeleton
          templateType={isGridLayout ? "grid" : "line"}
          count={3}
          designTokens={designTokens}
          matchContentLayout={isGridLayout}
          isMobileView={isMobileView}
          isDashboard={false}
        />
      </div>
    );
  }

  if (data && data.length) {
    return (
      <>
        {titleEl}
        <div
          className={`creator-card-grid-wrp ${
            isGridLayout
              ? `grid-layout ${isMobileView ? "mobile-view" : ""}`
              : "line-layout"
          }`}
        >
          {data.map((card: any, index: any) => {
            const layoutCard = withLayoutDisplayImage(
              card,
              isGridLayout ? "grid" : "line",
            );
            return isGridLayout ? (
              <GridTemplate
                key={index}
                card={layoutCard}
                onRemove={handleRemoveTemplate}
                username={username}
                user_id={user_id}
                componentName={name}
                isDashboard={false}
                brand_color={brand_color}
                handleRedirect={handleRedirect}
                from={from}
                pageFrom={pageFrom}
                designTokens={designTokens}
                componentId={componentId}
                isMobileView={isMobileView}
              />
            ) : (
              <LineTemplate
                key={index}
                card={layoutCard}
                onRemove={handleRemoveTemplate}
                username={username}
                user_id={user_id}
                componentName={name}
                isDashboard={false}
                brand_color={brand_color}
                handleRedirect={handleRedirect}
                from={from}
                pageFrom={pageFrom}
                designTokens={designTokens}
                componentId={componentId}
                isMobileView={isMobileView}
              />
            );
          })}
        </div>
      </>
    );
  }

  // Editor only: keep a clickable frame so Edit / add-links works on empty sections.
  if (websiteEdit) {
    return (
      <div className="mte-lib-links-empty" data-lib-links-empty="true">
        {titleEl}
        <p className="mte-lib-links-empty-hint" role="status">
          Click Edit to add links to this section.
        </p>
      </div>
    );
  }

  return null;
};

export default LinksComponentFrontend;
